import 'dayjs/locale/en'; // 영어 로케일을 사용합니다.

import React from 'react';

import DeleteRedIcon from 'assets/images/icon/DeleteRedIcon';
import EditIcon from 'assets/images/icon/EditIcon';
import dayjs from 'dayjs';
import {cloneDeep} from 'lodash';
import styled from 'styled-components';
import {textTransform} from 'util/textTransform';
import {CheckBox} from 'view/components/common/CheckBox';
import {PiAlignBottom, PiUserSwitchBold} from "react-icons/pi";
import {ImCodepen} from "react-icons/im";
import {FaArrowUpRightDots} from "react-icons/fa6";
import {FaBatteryThreeQuarters} from "react-icons/fa";
import {MdBusiness} from "react-icons/md";
import {FiCoffee} from "react-icons/fi";
import {GrGrow} from "react-icons/gr";
import {RiMoneyCnyBoxLine} from "react-icons/ri";

interface StyledComponentProps {
    width?: string;
}

const PurchaseListItem = (props) => {
    const {
        id, accessStatusEntity, userSeq, location,
        firstName, lastName, createDateTime, updatedDatetime, email, jobTitle, joinStatus
    } =
        props?.data;

    const returnData = (date) => {
        const c = cloneDeep(date)?.map((item, index) => {
            if (index === 1) {
                item = item - 1;
            }
            return item;
        });
        let ms = dayjs(Date.UTC.apply(null, c?.slice(0, 6)))
            .utc()
            .locale("en")
            .format("MMM DD, YYYY");
        return ms;
    };

    console.log("@userdata", props?.data);

    return (
        <Container>

            <Col width={"130px"}>
                <span style={{fontSize: 13, lineHeight: 1.2}}>
                    Joanna Lendim John
                </span>
            </Col>
            <Col width={"102px"}>
                <span>Coaching</span>
            </Col>

            <Col width={"130px"} style={{}}>
                <input
                    type="text"
                    style={{width: 130, fontSize: 12}}
                    value={"Expose some lecture or coaching titles"}
                    readOnly={true}
                />
            </Col>
            <Col width={"130px"}>
                <span>
                    {/*{returnData(createDateTime)}*/}
                    Apr 22, 2023
                </span>
            </Col>
            <Col width={"100px"}>
                {/*<span>{returnData(updatedDatetime)}</span>*/}
                <span>Refunded</span>
            </Col>
            <Col width={"100px"}>
                <View>
                    <span>
                        view
                    </span>
                </View>
            </Col>
        </Container>
    );
};
export default PurchaseListItem;

const Container = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    height: 68px;
    border-bottom: solid 1px #e9edf5;
    /* overflow-x: scroll; */
    padding: 0 20px;
    /* width: 100%; */
`;
const View = styled.div`
    border-radius: 3px;

    span {
        margin-bottom: 0;
        border-radius: 3px;
        display: flex;
        background: rgba(221, 193, 96, 1);
        width: 70px !important;
        height: 25px !important;
        cursor: pointer;
        font-family: Europa-Regular;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0em;
        justify-content: center;
        align-items: center;
    }

`
const Col = styled.div<StyledComponentProps>`
    display: flex;
    align-items: center;
    word-wrap: break-word;
    white-space: pre-wrap;
    width: ${(props) => (props.width ? `${props.width}` : "auto")};
    min-width: ${(props) => (props.width ? `${props.width}` : "auto")};
    flex-wrap: wrap;
        /* min-width: ${(props) => (props.width ? `calc(${props.width} / 100%)` : "auto")}; */
    margin: 0 10px;
    overflow-wrap: break-word;
    justify-content: flex-start;

    &:nth-child(1) {
        margin-left: 0;
        margin-right: 0.5%;
    }

    &:last-child {
        margin-right: 0;
    }

    span {
        width: 100%;
        padding-top: 1px;
        font-size: 14px;
        color: #333333d5;
    }

    input {
        display: flex;
        height: 30px;
        font-size: 14px;
        color: #333333d5;
        border: solid 1px #ddd;
        border-radius: 4px;
        padding: 4px;
    }
`;

const Icons = styled.div`
    display: flex;
    align-items: center;
`;
const Icon = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
`;
